<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <v-data-table
          :headers="headers"
          :items="data"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.country_name }}</td>
              <td>{{ props.item.state_name }}</td>
              <td style="display: flex; flex-direction: row">
                <v-btn
                  class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
                  fab
                  small
                  @click="editButtonClick(props.item)"
                >
                  <v-icon dark>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  class="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1"
                  fab
                  small
                  @click="deleteButtonClick(props.item)"
                >
                  <v-icon dark>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>

          <template v-slot:top>
            <v-btn
              class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
              fab
              small
              @click="createFormEnable"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </div>
      <div class="col-md-4">
        <!-- create form start -->
        <v-form ref="form" v-if="createForm" v-model="valid" lazy-validation>
          <v-text-field
            v-model="state"
            :rules="nameRules"
            label="State name"
            required
          ></v-text-field>
          <b-form-select
            v-model="country_id"
            :options="countriesOptions"
            size="sm"
            class="mt-3"
          ></b-form-select>
          <div style="margin-top: 5%">
            <v-btn
              class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
              @click="createState"
            >
              Save
            </v-btn>
            <v-btn
              style="margin-left: 6%"
              class="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1"
              @click="cancel"
            >
              Cancel
            </v-btn>
          </div>
        </v-form>
        <!-- create form end -->

        <!-- update form start -->
        <v-form ref="form" v-if="updateForm" v-model="valid" lazy-validation>
          <v-text-field
            v-model="state"
            :rules="nameRules"
            label="State name"
            required
          ></v-text-field>
          <b-form-select
            v-model="country_id"
            :options="countriesOptions"
            size="sm"
            class="mt-3"
          ></b-form-select>
          <div style="margin-top: 5%">
            <v-btn
              class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
              @click="updateState"
            >
              Update
            </v-btn>
            <v-btn
              style="margin-left: 6%"
              class="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1"
              @click="cancel"
            >
              Cancel
            </v-btn>
          </div>
        </v-form>
        <!-- update form end -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/core/api";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      loading: true,
      success: false,
      token: `Bearer ${localStorage.getItem("token")}`,
      valid: true,
      createForm: false,
      updateForm: false,
      state: "",
      state_id: null,
      country_id: null,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      headers: [
        { text: "Country Name", value: "country_name" },
        { text: "State Name", value: "state_name" },
        { text: "Action", value: "action" },
      ],
      data: [],
      countriesOptions: [{ value: null, text: "Please select country" }],
      countries: [],
    };
  },
  mounted() {var link = !!document.querySelector("link[rel='canonical']") ? document.querySelector("link[rel='canonical']") : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', location.protocol + '//' + location.host + location.pathname);
    document.head.appendChild(link);
    this.fetch();
    this.fetchCountries();
  },
  methods: {
    cancel() {
      this.createForm = false;
      this.updateForm = false;
      this.state = "";
      this.country_id = null;
    },
    createFormEnable() {
      this.country = "";
      this.createForm = true;
      this.updateForm = false;
    },
    fetch() {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/states`)
        .then((res) => {
          this.data = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchCountries() {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .get(`${API_URL}/countries`)
        .then((res) => {
          this.countries = res.data;
          res.data.forEach((element) => {
            this.countriesOptions.push({
              value: element.id,
              text: element.country_name,
            });
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    createState() {
      if ((this.state == "", this.country_id == null)) {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API_URL}/states`, {
          country_id: this.country_id,
          state_name: this.state,
        })
        .then((res) => {
          this.loading = false;
          this.success = true;
          this.state = "";
          Swal.fire({
            title: "",
            text: "State added",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    updateState() {
      if ((this.state == "", this.country_id == null)) {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .put(`${API_URL}/states/${this.state_id}`, {
          country_id: this.country_id,
          state_name: this.state,
        })
        .then((res) => {
          this.loading = false;
          this.success = true;
          this.state = "";
          Swal.fire({
            title: "",
            text: "State updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    editButtonClick(item) {
      this.createForm = false;
      this.updateForm = true;
      this.state = item.state_name;
      this.state_id = item.id;
      this.country_id = item.country_id;
    },
    deleteButtonClick(item) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .delete(`${API_URL}/states/${item.id}`)
        .then((res) => {
          Swal.fire({
            title: "",
            text: "State deleted",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.fetch();
          this.loading = false;
        })
        .catch(() => {
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.loading = false;
        });
    },
  },
};
</script>
